
import React from "react";
import { Th, Tr, Thead } from "../StatisticDesign";

const StatisticTableHead = ({ Dates = [] }) => {
    // console.log(Dates);
    return (
        <Thead>
            <Tr>
                <Th></Th>
                <Th></Th>
                <Th></Th>

                {Dates.map((date) => (
                    <Th key={date}>{date}</Th>
                ))}
            </Tr>
        </Thead>
    );
};

export default StatisticTableHead;
